export default {"src":"/_next/static/media/profile-pro.ade2f5e9.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};